import en from './en'
import pt from './pt-br'
import es from './es'
import bn from './bn'
import zhHans from './zh-Hans'
import zhHant from './zh-Hant'
import ja from './ja-jp'
import ur from './ur'
export default {
  en,
  pt,
  es,
  bn,
  ja,
  ur,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
}